<dl class="description-list">
  <ng-content />
</dl>
